import React, { memo } from 'react';
import PageHeader from '../components/PageHeader';
import ImageWithFallback from '../components/ImageWithFallback';
import { Briefcase, Users, Target, Award, CheckCircle, Phone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
const Corporate = () => {
  const services = [{
    icon: Briefcase,
    title: 'Corporate Retreats',
    description: 'Team-building retreats designed to strengthen collaboration and boost morale in inspiring locations.'
  }, {
    icon: Users,
    title: 'Incentive Travel',
    description: 'Reward top performers with memorable travel experiences that motivate and inspire.'
  }, {
    icon: Target,
    title: 'Conference Planning',
    description: 'End-to-end management of corporate events, conferences, and meetings in domestic and international venues.'
  }, {
    icon: Award,
    title: 'Executive Tours',
    description: 'Exclusive travel arrangements for executives with premium services and privacy.'
  }];
  const benefits = ['Customized itineraries aligned with your corporate objectives', 'Seamless logistics management from start to finish', 'Halal-friendly options for dining and activities', 'Team-building activities that strengthen company culture', 'Access to unique venues and experiences', 'Dedicated corporate travel specialist', '24/7 support throughout your journey', 'Detailed reporting and budget management'];
  return <div className="w-full" data-id="element-614">
      <PageHeader title="Corporate Services" subtitle="Elevate your business events with our specialized corporate travel solutions" backgroundImage="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" data-id="element-615" />
      {/* Introduction */}
      <section className="py-16 bg-white" data-id="element-616">
        <div className="container mx-auto px-4 md:px-8" data-id="element-617">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-618">
            <div data-id="element-619">
              <h2 className="text-3xl font-bold text-navy-900 mb-6" data-id="element-620">
                Corporate Travel Excellence
              </h2>
              <p className="text-navy-700 text-lg mb-6" data-id="element-621">
                At Kembara Ustaz, we understand that business travel requires
                precision, professionalism, and attention to detail. Our
                corporate services division specializes in creating meaningful
                business travel experiences that align with your company's
                objectives and values.
              </p>
              <p className="text-navy-700 text-lg mb-8" data-id="element-622">
                From team-building retreats to executive tours, we handle all
                aspects of your corporate travel needs with the highest level of
                service and cultural sensitivity.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-623">
                <a href="#contact-form" className="bg-navy-900 hover:bg-navy-800 text-white px-8 py-3 rounded-md font-medium transition-colors" data-id="element-624">
                  Request a Consultation
                </a>
                <Link to="/corporate/case-studies" className="bg-transparent border-2 border-navy-900 hover:bg-navy-900 hover:text-white text-navy-900 px-8 py-3 rounded-md font-medium transition-colors" data-id="element-625">
                  View Case Studies
                </Link>
              </div>
            </div>
            <div className="relative" data-id="element-626">
              <ImageWithFallback src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" alt="Corporate Retreat" className="rounded-lg shadow-lg" data-id="element-627" />
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gold-500 rounded-lg -z-10" data-id="element-628"></div>
            </div>
          </div>
        </div>
      </section>
      {/* Services */}
      <section className="py-16 bg-navy-50" data-id="element-629">
        <div className="container mx-auto px-4 md:px-8" data-id="element-630">
          <h2 className="text-3xl font-bold text-center text-navy-900 mb-12" data-id="element-631">
            Our Corporate Services
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-632">
            {services.map((service, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-633">
                <div className="w-14 h-14 bg-navy-900 rounded-full flex items-center justify-center mb-4" data-id="element-634">
                  <service.icon size={24} className="text-gold-500" data-id="element-635" />
                </div>
                <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-636">
                  {service.title}
                </h3>
                <p className="text-navy-700" data-id="element-637">{service.description}</p>
              </div>)}
          </div>
        </div>
      </section>
      {/* Case Study */}
      <section className="py-16 bg-white" data-id="element-638">
        <div className="container mx-auto px-4 md:px-8" data-id="element-639">
          <h2 className="text-3xl font-bold text-center text-navy-900 mb-12" data-id="element-640">
            Featured Case Study
          </h2>
          <div className="bg-navy-50 rounded-lg overflow-hidden shadow-lg" data-id="element-641">
            <div className="grid md:grid-cols-2" data-id="element-642">
              <div className="h-full" data-id="element-643">
                <ImageWithFallback src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" alt="Corporate Retreat in Bali" className="w-full h-full object-cover" data-id="element-644" />
              </div>
              <div className="p-8" data-id="element-645">
                <div className="text-sm font-medium text-gold-500 mb-2" data-id="element-646">
                  CASE STUDY
                </div>
                <h3 className="text-2xl font-bold text-navy-900 mb-4" data-id="element-647">
                  Annual Leadership Retreat for Tech Company
                </h3>
                <p className="text-navy-700 mb-6" data-id="element-648">
                  We organized a 5-day leadership retreat in Bali for a leading
                  tech company, combining strategic planning sessions with
                  team-building activities and cultural experiences.
                </p>
                <div className="mb-6" data-id="element-649">
                  <div className="flex items-center mb-2" data-id="element-650">
                    <CheckCircle size={20} className="text-gold-500 mr-2" data-id="element-651" />
                    <span className="text-navy-700" data-id="element-652">
                      100% halal-friendly arrangements
                    </span>
                  </div>
                  <div className="flex items-center mb-2" data-id="element-653">
                    <CheckCircle size={20} className="text-gold-500 mr-2" data-id="element-654" />
                    <span className="text-navy-700" data-id="element-655">
                      Custom team-building activities
                    </span>
                  </div>
                  <div className="flex items-center mb-2" data-id="element-656">
                    <CheckCircle size={20} className="text-gold-500 mr-2" data-id="element-657" />
                    <span className="text-navy-700" data-id="element-658">
                      Executive meeting facilities
                    </span>
                  </div>
                  <div className="flex items-center" data-id="element-659">
                    <CheckCircle size={20} className="text-gold-500 mr-2" data-id="element-660" />
                    <span className="text-navy-700" data-id="element-661">
                      Cultural immersion experiences
                    </span>
                  </div>
                </div>
                <div className="italic text-navy-700 mb-6" data-id="element-662">
                  "Kembara Ustaz delivered an exceptional retreat that perfectly
                  balanced our business objectives with meaningful team
                  experiences. The attention to detail and cultural sensitivity
                  was outstanding."
                </div>
                <div className="text-navy-900 font-medium" data-id="element-663">
                  - Ahmad Rashid, CEO, TechVision Solutions
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Benefits */}
      <section className="py-16 bg-navy-900 text-white" data-id="element-664">
        <div className="container mx-auto px-4 md:px-8" data-id="element-665">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-666">
            Why Choose Our Corporate Services
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-667">
            {benefits.map((benefit, index) => <div key={index} className="flex items-start" data-id="element-668">
                <CheckCircle size={24} className="text-gold-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-669" />
                <p data-id="element-670">{benefit}</p>
              </div>)}
          </div>
        </div>
      </section>
      {/* Contact Form */}
      <section id="contact-form" className="py-16 bg-white" data-id="element-671">
        <div className="container mx-auto px-4 md:px-8" data-id="element-672">
          <div className="max-w-3xl mx-auto" data-id="element-673">
            <h2 className="text-3xl font-bold text-center text-navy-900 mb-8" data-id="element-674">
              Request a Corporate Consultation
            </h2>
            <form className="bg-navy-50 p-8 rounded-lg shadow-md" data-id="element-675">
              <div className="grid md:grid-cols-2 gap-6" data-id="element-676">
                <div data-id="element-677">
                  <label className="block text-navy-900 font-medium mb-2" data-id="element-678">
                    Company Name
                  </label>
                  <input type="text" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500" placeholder="Your company name" data-id="element-679" />
                </div>
                <div data-id="element-680">
                  <label className="block text-navy-900 font-medium mb-2" data-id="element-681">
                    Contact Person
                  </label>
                  <input type="text" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500" placeholder="Your name" data-id="element-682" />
                </div>
                <div data-id="element-683">
                  <label className="block text-navy-900 font-medium mb-2" data-id="element-684">
                    Email
                  </label>
                  <input type="email" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500" placeholder="Your email address" data-id="element-685" />
                </div>
                <div data-id="element-686">
                  <label className="block text-navy-900 font-medium mb-2" data-id="element-687">
                    Phone
                  </label>
                  <input type="tel" className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500" placeholder="Your phone number" data-id="element-688" />
                </div>
                <div className="md:col-span-2" data-id="element-689">
                  <label className="block text-navy-900 font-medium mb-2" data-id="element-690">
                    Service Interest
                  </label>
                  <select className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500" data-id="element-691">
                    <option value="" data-id="element-692">Select a service</option>
                    <option value="retreat" data-id="element-693">Corporate Retreat</option>
                    <option value="incentive" data-id="element-694">Incentive Travel</option>
                    <option value="conference" data-id="element-695">Conference Planning</option>
                    <option value="executive" data-id="element-696">Executive Tours</option>
                    <option value="other" data-id="element-697">Other</option>
                  </select>
                </div>
                <div className="md:col-span-2" data-id="element-698">
                  <label className="block text-navy-900 font-medium mb-2" data-id="element-699">
                    Message
                  </label>
                  <textarea className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500 h-32" placeholder="Tell us about your requirements" data-id="element-700"></textarea>
                </div>
              </div>
              <button type="submit" className="mt-6 bg-navy-900 hover:bg-navy-800 text-white px-8 py-3 rounded-md font-medium transition-colors w-full md:w-auto" data-id="element-701">
                Submit Request
              </button>
            </form>
          </div>
        </div>
      </section>
      {/* Direct Contact */}
      <section className="py-16 bg-navy-50" data-id="element-702">
        <div className="container mx-auto px-4 md:px-8 text-center" data-id="element-703">
          <h2 className="text-2xl font-bold text-navy-900 mb-6" data-id="element-704">
            Speak Directly with Our Corporate Team
          </h2>
          <div className="flex flex-col md:flex-row justify-center gap-6 mb-8" data-id="element-705">
            <a href="tel:+6567213357" className="flex items-center justify-center bg-white p-4 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-706">
              <Phone size={24} className="text-gold-500 mr-3" data-id="element-707" />
              <span className="text-navy-900 font-medium" data-id="element-708">+65 6721 3357</span>
            </a>
            <a href="mailto:corporate@kembarauztaz.com" className="flex items-center justify-center bg-white p-4 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-709">
              <Mail size={24} className="text-gold-500 mr-3" data-id="element-710" />
              <span className="text-navy-900 font-medium" data-id="element-711">
                corporate@kembarauztaz.com
              </span>
            </a>
          </div>
        </div>
      </section>
    </div>;
};
export default Corporate;